import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { SiteService } from "../../shared/services/site/site.service";
import { CommonService, FutureOperationalHoursService } from "../../shared/services";
import {
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { FutureOperationalHours } from "../../shared/interface/future-operational-hours";
import { Observable, Subject } from "rxjs";
import { Sites } from "../../shared/interface/future-operational-hours";
import { map, startWith, takeUntil } from "rxjs/operators";

@Component({
    selector: "app-future-operational-hours",
    templateUrl: "./future-operational-hours.component.html",
    styleUrls: ["./future-operational-hours.scss"],
    encapsulation: ViewEncapsulation.None
})
export class FutureOperationalHoursComponent implements OnInit, OnDestroy {
    dataSource: FutureOperationalHours[];
    private _unsubscribeAll  : Subject<any> = new Subject<any>();
    
    constructor(public dialog: MatDialog, private futureOperationalHoursService: FutureOperationalHoursService) { }

    ngOnInit() {
        this.setList();
        this.futureOperationalHoursService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
            if (["create", "update"].includes(data.action)) {
                this.setList();
            }
        });
    }

    ngOnDestroy(){
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    setList() {
        this.futureOperationalHoursService.list().pipe(takeUntil(this._unsubscribeAll)).subscribe(
            res => {
                this.dataSource = res;
            },
            err => { }
        );
    }

    openOperationalHoursDialog = (data = {}) => {
        this.dialog.open(FutureOperationalHoursDialog, {
            data: data,
            height: "auto",
            width: "800px",
            panelClass: "full-modal"
        });
    };

    public delete(_id) {
        if (
            confirm(
                "Are you sure you want to remove this future operational hour."
            ) == false
        ) {
            return false;
        }

        let temp = this.dataSource;
        this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);
        this.futureOperationalHoursService.delete(_id).pipe(takeUntil(this._unsubscribeAll)).subscribe(
            r => {
                this.futureOperationalHoursService.sendAction("update", "");
            },
            e => {
                this.dataSource = temp;
            }
        );
    }
}

@Component({
    selector: "future-operational-hours-dialog",
    templateUrl: "future-operational-hours.dialog.html"
})
export class FutureOperationalHoursDialog implements OnInit {
    @ViewChild('searchSite') searchSite: ElementRef;
    futureOperationalHourForm: FormGroup;
    isSubmitted: number = 0;
    //add more oprational hours
    oHAddCount: number = 1;
    oHMaxCount: number = 3;
    siteList = [];
    multiOperationalHours = [];
    week: string[] = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    multiFullWeek = [];
    //site opens on day
    openingDays = [];
    ownerId: string = "";
    searchSiteControl = new FormControl('');
    filteredSite: Observable<Sites[]>;
    selectedSite : string[]= [];
    currentDate = new Date();
    nextDate = new Date();

    constructor(private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private futureOperationalHoursService: FutureOperationalHoursService,
        public dialogRef: MatDialogRef<FutureOperationalHoursDialog>,
        private siteService: SiteService,
        public commonService: CommonService) {
        data = this.parseData(data);
        this.createForm(data);
        this.selectedSite = data.sites;
        this.siteService.list("fields=siteName&sort=siteName-asc").subscribe(res => {
            this.siteList = res;
            this.filteredSite = this.searchSiteControl.valueChanges.pipe(startWith<string>(''), map(name => this.filterSite(name)));
        })
        this.nextDate.setDate(this.nextDate.getDate() +1);
    }

    ngOnInit(): void {
        this.ownerId = this.commonService.getLoggedInUser() ? this.commonService.getLoggedInUser().ownerId : "";
        this.filteredSite = this.searchSiteControl.valueChanges.pipe(startWith<string>(''), map(name => this.filterSite(name)));
    }

    filterSite(value: string): Sites[] {
        let filteredList = this.siteList.filter((c) => c.siteName.toLowerCase().indexOf(value.toLowerCase()) > -1);
        return filteredList;
    }

    setDefaultDataForOperationalHours(k) {
        this.multiOperationalHours[k] = [];
        this.week.forEach((v, i) => {
            this.multiOperationalHours[k].push({
                day: i + 1,
                activeDay: false,
                endOn: "sameDay",
                from: "",
                to: ""
            });
        });
    }

    parseData(data: any) {
        //creating 1st operational hours
        this.setDefaultDataForOperationalHours(0);
        if (data && data._id) {
            //if it has multiple oprational hours
            if (data.multiOperationalHours.length > 1) {
                this.oHAddCount = data.multiOperationalHours.length;
                data.multiOperationalHours.forEach((oh, k) => {
                    this.setDefaultDataForOperationalHours(k);
                });
            }

            if (data.defaultOperationalHours.from > data.defaultOperationalHours.to) {
                data.defaultOperationalHours.endOn = data.defaultOperationalHours.endOn == "nextDay" ? "sameDay" : data.defaultOperationalHours.endOn;

                //array of multiple operational hours
                if (data.multiOperationalHours && data.multiOperationalHours.length > 0) {
                    data.multiOperationalHours.forEach((oH, i) => {
                        oH.forEach((oHDay, j) => {
                            //set opetainal hours from server data
                            data.multiOperationalHours[i].forEach(e => {
                                if (data.multiOperationalHours[i][j].from > data.multiOperationalHours[i][j].to) {
                                    data.multiOperationalHours[i][j].endOn = data.multiOperationalHours[i][j].endOn == "nextDay" ? "sameDay" : data.multiOperationalHours[i][j].endOn
                                }
                            });
                        });
                    });
                }
            }

            if (data.dateFrom && Object.prototype.toString.call(data.dateFrom) != '[object Date]')
                data.dateFrom = data.dateFrom.replace('T', ' ').slice(0, -5);

            data.dateFrom = this.commonService.getOffsetConvertedSite(data.dateFrom, "YYYY-MM-DD HH:mm:ss");
            data.updateType = "future";
            //send validated data
            return data;
        }

        //if creating new record
        return {
            _id: "",
            sites: [],
            multiOperationalHours: [],
            dateFrom: "",
            dateTo: "",
            updateType: "past",
            openingDays: this.openingDays,
            defaultOperationalHours: {
                from: "",
                endOn: "sameDay",
                to: ""
            },
        };
    }


    createForm = (data: any) => {
        this.futureOperationalHourForm = this.fb.group({
            _id: [data._id],
            sites: [data.sites, Validators.required],
            defaultOperationalHours: this.fb.group({
                endOn: [data.defaultOperationalHours.endOn, Validators.required],
                from: this.dbTimeToPickerTime(data.defaultOperationalHours.from),
                to: this.dbTimeToPickerTime(data.defaultOperationalHours.to),
            }),
            openingDays: [data.openingDays],
            dateFrom: [data.dateFrom],
            from: [''],
            to: [''],
            updateType: [data.updateType],
            multiOperationalHours: this.fb.array([]),
        });
        this.setOperationalHours(data.multiOperationalHours);
        if (data && !data._id)
            this.setValidationOnDate();
    };

    //set data for operational hours
    setOperationalHours(operationalHoursFromData: any = []) {
        let isFullWeek = 0;
        if (operationalHoursFromData.length > 0 && !operationalHoursFromData[0].day) {

            //array of multiple operational hours
            this.multiOperationalHours.forEach((oH, i) => {
                this.multiFullWeek[i] = 0;
                isFullWeek = 0;
                //operational hours
                oH.forEach((oHDay, j) => {

                    //set opetainal hours from server data
                    operationalHoursFromData[i].forEach(e => {
                        if (oHDay.day == e.day) {
                            this.multiOperationalHours[i][j].activeDay = (e.isOpen == 0 ? false : true);
                            this.multiOperationalHours[i][j].from = this.dbTimeToPickerTime(e.from);
                            this.multiOperationalHours[i][j].endOn = e.endOn;
                            this.multiOperationalHours[i][j].to = this.dbTimeToPickerTime(e.to);
                            isFullWeek += 1;
                        }
                    });
                });


                //in UI set full week toggle true
                //if all 7 are selected
                if (isFullWeek == 7) {                    
                    this.multiFullWeek[i] = 1;
                }


            });
        }

        let multioHFormArray = [];
        //array of multiple operational hours
        this.multiOperationalHours.forEach((oH, i) => {

            //single operational hours
            const oHFGs = oH.map(oHDay => this.fb.group(oHDay));
            const oHFormArray = this.fb.array(oHFGs);
            multioHFormArray.push(oHFormArray);
        });

        //set multiple oprational hours array
        this.futureOperationalHourForm.setControl("multiOperationalHours", this.fb.array(multioHFormArray));
    }

    setValidationOnDate() {
        if (this.futureOperationalHourForm.controls['updateType'].value == "past") {
            this.futureOperationalHourForm.get('dateFrom').patchValue("");
            this.futureOperationalHourForm.get('from').clearValidators();
            this.futureOperationalHourForm.get('to').clearValidators();
            this.futureOperationalHourForm.get('from').setValidators([Validators.required]);
            this.futureOperationalHourForm.get('to').setValidators([Validators.required]);
            this.futureOperationalHourForm.get('from').updateValueAndValidity();
            this.futureOperationalHourForm.get('to').updateValueAndValidity();
        } else {
            this.futureOperationalHourForm.get('from').patchValue("");
            this.futureOperationalHourForm.get('to').patchValue("");
            this.futureOperationalHourForm.get('dateFrom').clearValidators();
            this.futureOperationalHourForm.get('from').clearValidators();
            this.futureOperationalHourForm.get('to').clearValidators();
            this.futureOperationalHourForm.get('dateFrom').setValidators([Validators.required]);
            this.futureOperationalHourForm.get('dateFrom').updateValueAndValidity();
            this.futureOperationalHourForm.get('from').updateValueAndValidity(); 
            this.futureOperationalHourForm.get('to').updateValueAndValidity(); 
        }
    }

    getAllOperationalHours() {
        return <FormArray>this.futureOperationalHourForm.get('multiOperationalHours');
    }

    getOperationalHours(k) {
        return <FormArray>this.futureOperationalHourForm.get('multiOperationalHours.' + k);
    }

    addMoreOprationalHours() {
        this.setDefaultDataForOperationalHours(this.oHAddCount);
        this.getAllOperationalHours().push(this.fb.array(
            this.multiOperationalHours[this.multiOperationalHours.length - 1].map(oHDay => this.fb.group(oHDay))
        ));
        this.oHAddCount++;
    }

    removeOperationalHours(index) {
        if (confirm("Are you sure you want to remove this operational hours?") == false) {
            return false;
        }
        this.getAllOperationalHours().removeAt(index);
        this.oHAddCount--;
        this.multiFullWeek[index] = (this.multiFullWeek[index + 1] ? this.multiFullWeek[index + 1] : 0)
    }

    selectFullWeek(k) {
        this.multiFullWeek[k] = (this.multiFullWeek[k] ? 0 : 1);
        let value = this.multiFullWeek[k];
        this.week.forEach((v, i) => {
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.activeDay').setValue(value);
            if (value) {
                this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue(this.futureOperationalHourForm.get('defaultOperationalHours.from').value);
                this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue(this.futureOperationalHourForm.get('defaultOperationalHours.endOn').value);
                this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue(this.futureOperationalHourForm.get('defaultOperationalHours.to').value);
            } else {
                this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue("");
                this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue("");
                this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue("");
            }
        })
    }
    //set operational hours to default on active
    setOhValue(value, k, i) {
        if (value) {
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue(this.futureOperationalHourForm.get('defaultOperationalHours.from').value);
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue(this.futureOperationalHourForm.get('defaultOperationalHours.endOn').value);
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue(this.futureOperationalHourForm.get('defaultOperationalHours.to').value);
        } else {
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue("");
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue("");
            this.futureOperationalHourForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue("");
        }
    }

    blockInput($event) {
        $event.preventDefault();
    }

    dbTimeToPickerTime(time) {
        let dateToday = new Date();
        let timeArray = time.split(':');
        let datt = new Date(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate(), timeArray[0], timeArray[1], timeArray[2]);
        let convertedDate = this.commonService.getDateConverted(datt, "YYYY-MM-DD HH:mm:ss");
        return new Date(convertedDate);
    }

    pickerTimeToDBTime(pDate) {
        let dtf = pDate;
        let convertedDate = new Date(this.commonService.getDateConverted(dtf, "YYYY-MM-DD HH:mm:ss"));
        let sdf2 = this.addZero(convertedDate.getHours()) + ':' + this.addZero(convertedDate.getMinutes()) + ':' + this.addZero(convertedDate.getSeconds());
        return sdf2;
    }

    addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }

    onSubmit(f: any) {
        let form = Object.assign({}, f);

        if (!this.futureOperationalHourForm.valid) {
            return false;
        }
        let updateType = form.updateType;
        this.isSubmitted = 1;

        let tempOperationDays = [];
        let tempOperationHrs = [];

        form.multiOperationalHours.forEach((oH, i) => {
            oH.forEach((v) => {
                if (v.activeDay) {
                    tempOperationDays.push(v.day);
                }
            });
        });
        form.openingDays = tempOperationDays;

        let from = this.pickerTimeToDBTime(typeof form.defaultOperationalHours.from == 'object' ? form.defaultOperationalHours.from : this.dbTimeToPickerTime(form.defaultOperationalHours.from));
        let tempF = from.split(':');

        let to = this.pickerTimeToDBTime(typeof form.defaultOperationalHours.to == 'object' ? form.defaultOperationalHours.to : this.dbTimeToPickerTime(form.defaultOperationalHours.to));
        let tempT = to.split(':');

        form.defaultOperationalHours.from = `${tempF[0]}:${tempF[1]}:00`;
        form.defaultOperationalHours.to = `${tempT[0]}:${tempT[1]}:59`;

        //modify array for operational days to set default days and time
        form.multiOperationalHours.forEach((oH, k) => {
            tempOperationHrs[k] = [];

            let from, to, tempF, tempT;
            oH.forEach((v, i) => {
                if (v.activeDay) {
                    if (v.from == "" || v.to == "") {
                        from = this.pickerTimeToDBTime(form.defaultOperationalHours.from);
                        tempF = from.split(':');
                        to = this.pickerTimeToDBTime(form.defaultOperationalHours.to);
                        tempT = to.split(':');

                        if (from > to)
                            form.defaultOperationalHours.endOn = form.defaultOperationalHours.endOn == "sameDay" ? "nextDay" : form.defaultOperationalHours.endOn;

                        v.endOn = form.defaultOperationalHours.endOn;
                        v.from = `${tempF[0]}:${tempF[1]}:00`;
                        v.to = `${tempT[0]}:${tempT[1]}:59`;
                    } else {
                        from = this.pickerTimeToDBTime(typeof v.from == 'object' ? v.from : this.dbTimeToPickerTime(v.from));
                        tempF = from.split(':');

                        to = this.pickerTimeToDBTime(typeof v.to == 'object' ? v.to : this.dbTimeToPickerTime(v.to));
                        tempT = to.split(':');

                        if (from > to)
                            oH[i].endOn = oH[i].endOn == "sameDay" ? "nextDay" : oH[i].endOn;

                        v.from = `${tempF[0]}:${tempF[1]}:00`;
                        v.to = `${tempT[0]}:${tempT[1]}:59`;
                    }
                    tempOperationHrs[k].push(oH[i]);
                }
            });
        });
        form.operationalHours = tempOperationHrs;

        let dateObj = { firstDay: "", lastDay: "" };
        let tempFrom = "";
        let tempTo = "";
        if (updateType == "future") {
            tempFrom = (typeof form.dateFrom == 'object' && form.dateFrom ? form.dateFrom._d : new Date(form.dateFrom));
        } else {
            tempFrom = form.from;
            tempTo = form.to;
        }

        if (tempFrom && Object.prototype.toString.call(tempFrom) != '[object Date]')
            tempFrom = tempFrom.replace(' ', 'T');
        if (tempTo && Object.prototype.toString.call(tempTo) != '[object Date]')
            tempTo = tempTo.replace(' ', 'T');
        dateObj = this.commonService.getFutureDate(tempFrom, tempTo, updateType);
        form.dateFrom = dateObj.firstDay;//dateObj.firstDay;
        form.dateTo = dateObj.lastDay;//dateObj.lastDay;

        if (updateType == "future") {
            delete form.from;
            delete form.to;
            delete form.dateTo;
        }


        if (updateType == "past") {
            let payload = {
                sites : form.sites,
                start_date : form.dateFrom,
                end_date : form.dateTo,
                operational_hours : form.multiOperationalHours[0]
            }
            this.futureOperationalHoursService.updateOperationalHours(payload, this.ownerId).subscribe(
                res => {
                    this.dialogRef.close();
                    this.isSubmitted = 0;
                },
                err => {
                    this.isSubmitted = 0;
                }
            );
        } else {
            // create futureOperationalHours
            if (form._id == "") {
                this.futureOperationalHoursService.create(form).subscribe(
                    res => {
                        this.dialogRef.close();
                        this.futureOperationalHoursService.sendAction("create", "");
                        this.isSubmitted = 0;
                    },
                    err => {
                        this.isSubmitted = 0;
                    }
                );
            } else {
                if (confirm(
                    "Do you want to override the current operational hour?") == false) {
                    this.isSubmitted = 0;
                    return false;
                }
                // Update futureOperationalHours
                form._id = form._id;
                this.futureOperationalHoursService.update(form).subscribe(
                    res => {
                        this.dialogRef.close();
                        this.futureOperationalHoursService.sendAction("update", "");
                        this.isSubmitted = 0;
                    },
                    err => {
                        this.isSubmitted = 0;
                    }
                );
            }
        }

    }

    clearSearch(e: any) {
        e.stopPropagation();
        this.searchSiteControl.patchValue('');
    }

    openedChange(isOpen: boolean) {
        if (isOpen) {
            this.searchSite.nativeElement.focus();
        }
        else {
            this.searchSiteControl.patchValue('');
        }
    }

    selectionSiteChange(event) {
        if (event.selected == false) {
            let index = this.selectedSite.indexOf(event.value);
            this.selectedSite.splice(index, 1);
            this.futureOperationalHourForm.patchValue({
                sites: this.selectedSite
            });
        }
        else {
            this.selectedSite = [...this.selectedSite, event.value];
            this.selectedSite = this.selectedSite.filter(function (i, p, s) {
                return s.indexOf(i) == p;
            })
            this.futureOperationalHourForm.patchValue({
                sites: this.selectedSite
            });
        }
    }
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/future-operational-hours/future-operational-hours.component.ts